import styled from 'styled-components'

export default styled.div`
	position: relative;
  box-sizing: border-box;
  max-width: 180px;
  margin-top: 4px;
  min-height: 16px;
  line-height: 16px;
  font-weight: 600;
  font-size: 12px;
  hyphens: auto;
`
